module.exports = __webpack_public_path__ + "img/topNav.8306867b.png";